import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const ProtectedRoute = ({ allowedRoles }: { allowedRoles?: string[] }) => {
    const { isAuthenticated, user } = useAuthStore(state => state);

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user?.role)) {
        // L'utilisateur n'a pas le bon rôle, on le renvoie vers son dashboard par défaut
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />; // Rend les composants enfants de la route
};

export default ProtectedRoute;
